import React from "react";
import { Button } from "../../../Common/Button";
import { IconNames } from "../../../Common/Icons/LucideIcons";

export const OperationsMenuButton = ({
  text,
  onClick,
  icon,
  disabled,
}: {
  text: string;
  onClick: () => void;
  icon: IconNames;
  disabled?: boolean;
}) => (
  <Button
    leftIconName={icon}
    styleVariant="outlineLight"
    size="small"
    onClick={onClick}
    disabled={disabled}
  >
    {text}
  </Button>
);

export default OperationsMenuButton;
